module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>'+
((__t=( i18n.tc("ApplicationInstall", "Not available in browser!") ))==null?'':__t)+
'</h4><p>'+
((__t=( i18n.tc("ApplicationInstall", "This DEFA device cannot be controlled directly from your browser yet!") ))==null?'':__t)+
'<br> '+
((__t=( i18n.tc("ApplicationInstall", "Search for, install and log in to the DEFA app on your smartphone to get started.") ))==null?'':__t)+
'</p><hr><p class="application-preview"><strong>'+
((__t=( i18n.tc("ApplicationInstall", "by DEFA AS") ))==null?'':__t)+
'</strong></p><hr><div class="centered-buttons-outer"><div class="centered-buttons-inner clearfix"><a href="https://play.google.com/store/apps/details?id=com.est.defa&utm_source=simplify&utm_medium=web-app&utm_campaign=not-in-browser" class="button icon-google-play">Get DEFA on Google Play</a> <a href="https://itunes.apple.com/app/defa/id542334548?utm_source=simplify&utm_medium=web-app&utm_campaign=not-in-browser" class="button icon-app-store">Get DEFA on App Store</a></div></div>';
}
return __p;
};
